// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatPanel.css - UPDATED VERSION - Purple borders and simple theme switch */

.chat-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 350px;
  height: 100vh;
  backdrop-filter: blur(10px);
  border-left: none;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  font-family: Arial, sans-serif;
  transition: transform 0.3s ease, background 0.3s ease, color 0.3s ease;
  color: #ffffff;
}

/* Dark mode shadow */
.chat-container.dark-mode {
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
}

/* Light mode - no shadow */
.chat-container.light-mode {
  box-shadow: none;
}

/* Dark mode styles (default) */
.chat-container.dark-mode {
  background: transparent; /* Let body background show through with backdrop blur */
  color: #ffffff;
}

/* Light mode styles */
.chat-container.light-mode {
  background: transparent; /* Let body background show through with backdrop blur */
  color: #ffffff;
}

.chat-container.collapsed {
  transform: translateX(calc(100% - 60px));
}

/* Chat Header */
.chat-header {
  background: #5b21b6;
  color: white;
  padding: 4px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 27px;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
}

/* Seasonal theme chat header with animated breathing gradient */
.app.seasonal-theme .chat-header {
  background: linear-gradient(
    90deg,
    #7c3aed,  /* VIVID purple */
    #ff6b00,  /* VIVID orange */
    #a21caf,  /* VIVID magenta */
    #7c3aed   /* VIVID purple */
  );
  background-size: 300% 100%;
  animation: borderFlow 60s ease-in-out infinite, borderPulse 45s ease-in-out infinite;
}

@keyframes borderFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes borderPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.95;
  }
}

/* Seasonal theme gradient border for chat input - wrapper approach */
.app.seasonal-theme .chat-input-container {
  position: relative;
  padding: 2px;
  background: linear-gradient(
    90deg,
    #7c3aed,  /* VIVID purple */
    #ff6b00,  /* VIVID orange */
    #a21caf,  /* VIVID magenta */
    #7c3aed   /* VIVID purple */
  );
  background-size: 300% 100%;
  animation: borderFlow 60s ease-in-out infinite, borderPulse 45s ease-in-out infinite;
  border-radius: 4px;
}

.app.seasonal-theme .dark-mode .chat-input {
  border: none !important;
  box-shadow: none !important;
  background: #1a1a1a !important;
  border-radius: 2px;
}

.app.seasonal-theme .light-mode .chat-input {
  border: none !important;
  box-shadow: none !important;
  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%) !important; /* Purple gradient */
  border-radius: 2px;
}

/* Seasonal theme - no gradient on left border of chat container */

.chat-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
}

.chat-toggle {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.chat-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* UPDATED: Simple theme toggle switch */
.theme-toggle {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s ease;
}

.theme-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.switch-container {
  display: flex;
  align-items: center;
}

.switch {
  width: 32px;
  height: 16px;
  border-radius: 8px;
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
}

.switch.dark {
  background: #374151;
}

.switch.light {
  background: #fbbf24;
}

.switch-handle {
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background: white;
  position: absolute;
  top: 2px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.switch.dark .switch-handle {
  left: 2px;
}

.switch.light .switch-handle {
  left: 18px;
}

/* CRITICAL LAYOUT FIX: Chat Content Container */
.chat-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: transparent;
  overflow: hidden;
  min-height: 0;
}

/* CRITICAL LAYOUT FIX: Messages Area - FORCE TO FILL SPACE */
.chat-messages {
  flex: 1;
  padding: 12px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  scrollbar-width: thin;
  box-sizing: border-box;
  min-height: calc(100vh - 27px - 60px); /* UPDATED: Updated for new 60px input area height */
}

/* CRITICAL LAYOUT FIX: Input Area - FIXED HEIGHT AT BOTTOM */
.chat-input-area {
  padding: 12px;
  flex-shrink: 0;
  background: inherit;
  position: relative;
  height: 60px; /* UPDATED: Reduced from 80px since chat-status removed */
  box-sizing: border-box;
}

/* Scrollbar Styling */
.dark-mode .chat-messages {
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.dark-mode .chat-messages::-webkit-scrollbar {
  width: 4px;
}

.dark-mode .chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.dark-mode .chat-messages::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.light-mode .chat-messages {
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.light-mode .chat-messages::-webkit-scrollbar {
  width: 4px;
}

.light-mode .chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.light-mode .chat-messages::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

/* UPDATED: Message Styling with Purple Borders (system messages changed from teal to purple) */
.dark-mode .chat-message {
  background: rgba(18, 18, 18, 0.8);
  border: 1px solid #8b5cf6; /* 1px purple border for regular messages */
  color: #ffffff;
}

.dark-mode .chat-message.system {
  background: rgba(46, 46, 46, 0.8);
  border: 1px solid #8b5cf6; /* UPDATED: Changed from teal to purple border */
  color: #c4b5fd;
}

.dark-mode .chat-message.error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444; /* 1px border */
  color: #dc2626;
}

.dark-mode .message-username {
  color: #c4b5fd;
}

.dark-mode .message-time {
  color: #9ca3af;
}

.light-mode .chat-message {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(139, 92, 246, 0.5); /* 1px purple border for regular messages */
  color: #ffffff; /* White text for readability */
}

.light-mode .chat-message.system {
  background: rgba(139, 92, 246, 0.15);
  border: 1px solid rgba(139, 92, 246, 0.6); /* UPDATED: Changed from teal to purple border */
  color: #e9d5ff; /* Light purple text */
}

.light-mode .chat-message.error {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.6); /* 1px border */
  color: #fca5a5; /* Light red text */
}

.light-mode .message-username {
  color: #c4b5fd; /* Light purple for username */
}

.light-mode .message-time {
  color: #d1d5db; /* Light gray for timestamp */
}

.chat-message {
  border-radius: 4px;
  padding: 8px 12px;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin: 0;
}

.chat-message.system {
  text-align: center;
  font-style: italic;
}

/* Seasonal theme gradient borders for chat messages - using border-image for simplicity */
.app.seasonal-theme .chat-message {
  border: 1px solid;
  border-image: linear-gradient(
    90deg,
    #7c3aed,  /* VIVID purple */
    #ff6b00,  /* VIVID orange */
    #a21caf   /* VIVID magenta */
  ) 1;
}

.message-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  width: 100%;
}

.message-username {
  font-weight: 600;
  font-size: 14px;
}

.message-time {
  font-size: 11px;
}

.message-content {
  font-size: 14px;
  line-height: 1.4;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap; /* Preserve newlines while allowing text wrapping */
}

/* Input Area Styling */
.dark-mode .chat-input-area {
  background: transparent;
}

.light-mode .chat-input-area {
  background: transparent;
}

.chat-input-container {
  display: flex;
  gap: 8px;
}

/* Input Fields */
.dark-mode .chat-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.05);
  color: white;
  font-size: 14px;
  outline: none;
}

.dark-mode .chat-input:focus {
  border-color: #5b21b6;
  box-shadow: 0 0 0 2px rgba(91, 33, 182, 0.2);
}

.dark-mode .chat-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.light-mode .chat-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  font-size: 14px;
  outline: none;
}

.light-mode .chat-input:focus {
  border-color: #5b21b6;
  box-shadow: 0 0 0 2px rgba(91, 33, 182, 0.2);
}

.light-mode .chat-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.chat-send {
  padding: 8px 16px;
  background: #5b21b6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.chat-send:hover:not(:disabled) {
  background: #4c1d95;
}

.chat-send:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.chat-status {
  margin-top: 4px;
  font-size: 12px;
  min-height: 14px;
}

.dark-mode .chat-status {
  color: #9ca3af;
}

.light-mode .chat-status {
  color: #6b7280;
}

/* REMOVED: Chat status styling since div was removed */
/* Seasonal pumpkin - hidden by default */
.seasonal-pumpkin {
  display: none;
  font-size: 32px;
}

/* Show pumpkin when seasonal theme is active */
.app.seasonal-theme .seasonal-pumpkin {
  display: inline;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .chat-container {
    width: 100vw;
    height: 100vh;
  }

  .chat-container.collapsed {
    transform: translateX(100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatPanel.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,8BAA8B;EAC9B,sEAAsE;EACtE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB,EAAE,wDAAwD;EACjF,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB,EAAE,wDAAwD;EACjF,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE;;;;;;GAMC;EACD,0BAA0B;EAC1B,oFAAoF;AACtF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,YAAY;EACZ;;;;;;GAMC;EACD,0BAA0B;EAC1B,oFAAoF;EACpF,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wEAAwE,EAAE,oBAAoB;EAC9F,kBAAkB;AACpB;;AAEA,kEAAkE;;AAElE;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA,6DAA6D;AAC7D;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,QAAQ;EACR,qBAAqB;EACrB,sBAAsB;EACtB,qCAAqC,EAAE,oDAAoD;AAC7F;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY,EAAE,yDAAyD;EACvE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,+FAA+F;AAC/F;EACE,iCAAiC;EACjC,yBAAyB,EAAE,2CAA2C;EACtE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB,EAAE,gDAAgD;EAC3E,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB,EAAE,eAAe;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,yCAAyC,EAAE,2CAA2C;EACtF,cAAc,EAAE,+BAA+B;AACjD;;AAEA;EACE,oCAAoC;EACpC,yCAAyC,EAAE,gDAAgD;EAC3F,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,mCAAmC;EACnC,wCAAwC,EAAE,eAAe;EACzD,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0FAA0F;AAC1F;EACE,iBAAiB;EACjB;;;;;KAKG;AACL;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB,EAAE,mDAAmD;AAC5E;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD,yCAAyC;AACzC;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ChatPanel.css - UPDATED VERSION - Purple borders and simple theme switch */\n\n.chat-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 350px;\n  height: 100vh;\n  backdrop-filter: blur(10px);\n  border-left: none;\n  display: flex;\n  flex-direction: column;\n  z-index: 10000;\n  font-family: Arial, sans-serif;\n  transition: transform 0.3s ease, background 0.3s ease, color 0.3s ease;\n  color: #ffffff;\n}\n\n/* Dark mode shadow */\n.chat-container.dark-mode {\n  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Light mode - no shadow */\n.chat-container.light-mode {\n  box-shadow: none;\n}\n\n/* Dark mode styles (default) */\n.chat-container.dark-mode {\n  background: transparent; /* Let body background show through with backdrop blur */\n  color: #ffffff;\n}\n\n/* Light mode styles */\n.chat-container.light-mode {\n  background: transparent; /* Let body background show through with backdrop blur */\n  color: #ffffff;\n}\n\n.chat-container.collapsed {\n  transform: translateX(calc(100% - 60px));\n}\n\n/* Chat Header */\n.chat-header {\n  background: #5b21b6;\n  color: white;\n  padding: 4px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 27px;\n  box-sizing: border-box;\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* Seasonal theme chat header with animated breathing gradient */\n.app.seasonal-theme .chat-header {\n  background: linear-gradient(\n    90deg,\n    #7c3aed,  /* VIVID purple */\n    #ff6b00,  /* VIVID orange */\n    #a21caf,  /* VIVID magenta */\n    #7c3aed   /* VIVID purple */\n  );\n  background-size: 300% 100%;\n  animation: borderFlow 60s ease-in-out infinite, borderPulse 45s ease-in-out infinite;\n}\n\n@keyframes borderFlow {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes borderPulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.95;\n  }\n}\n\n/* Seasonal theme gradient border for chat input - wrapper approach */\n.app.seasonal-theme .chat-input-container {\n  position: relative;\n  padding: 2px;\n  background: linear-gradient(\n    90deg,\n    #7c3aed,  /* VIVID purple */\n    #ff6b00,  /* VIVID orange */\n    #a21caf,  /* VIVID magenta */\n    #7c3aed   /* VIVID purple */\n  );\n  background-size: 300% 100%;\n  animation: borderFlow 60s ease-in-out infinite, borderPulse 45s ease-in-out infinite;\n  border-radius: 4px;\n}\n\n.app.seasonal-theme .dark-mode .chat-input {\n  border: none !important;\n  box-shadow: none !important;\n  background: #1a1a1a !important;\n  border-radius: 2px;\n}\n\n.app.seasonal-theme .light-mode .chat-input {\n  border: none !important;\n  box-shadow: none !important;\n  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%) !important; /* Purple gradient */\n  border-radius: 2px;\n}\n\n/* Seasonal theme - no gradient on left border of chat container */\n\n.chat-title {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chat-toggle {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.chat-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* UPDATED: Simple theme toggle switch */\n.theme-toggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: all 0.3s ease;\n}\n\n.theme-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.switch-container {\n  display: flex;\n  align-items: center;\n}\n\n.switch {\n  width: 32px;\n  height: 16px;\n  border-radius: 8px;\n  position: relative;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.switch.dark {\n  background: #374151;\n}\n\n.switch.light {\n  background: #fbbf24;\n}\n\n.switch-handle {\n  width: 12px;\n  height: 12px;\n  border-radius: 6px;\n  background: white;\n  position: absolute;\n  top: 2px;\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.switch.dark .switch-handle {\n  left: 2px;\n}\n\n.switch.light .switch-handle {\n  left: 18px;\n}\n\n/* CRITICAL LAYOUT FIX: Chat Content Container */\n.chat-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  overflow: hidden;\n  min-height: 0;\n}\n\n/* CRITICAL LAYOUT FIX: Messages Area - FORCE TO FILL SPACE */\n.chat-messages {\n  flex: 1;\n  padding: 12px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 8px;\n  scrollbar-width: thin;\n  box-sizing: border-box;\n  min-height: calc(100vh - 27px - 60px); /* UPDATED: Updated for new 60px input area height */\n}\n\n/* CRITICAL LAYOUT FIX: Input Area - FIXED HEIGHT AT BOTTOM */\n.chat-input-area {\n  padding: 12px;\n  flex-shrink: 0;\n  background: inherit;\n  position: relative;\n  height: 60px; /* UPDATED: Reduced from 80px since chat-status removed */\n  box-sizing: border-box;\n}\n\n/* Scrollbar Styling */\n.dark-mode .chat-messages {\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n}\n\n.dark-mode .chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.dark-mode .chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.dark-mode .chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n}\n\n.light-mode .chat-messages {\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n}\n\n.light-mode .chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.light-mode .chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.light-mode .chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 2px;\n}\n\n/* UPDATED: Message Styling with Purple Borders (system messages changed from teal to purple) */\n.dark-mode .chat-message {\n  background: rgba(18, 18, 18, 0.8);\n  border: 1px solid #8b5cf6; /* 1px purple border for regular messages */\n  color: #ffffff;\n}\n\n.dark-mode .chat-message.system {\n  background: rgba(46, 46, 46, 0.8);\n  border: 1px solid #8b5cf6; /* UPDATED: Changed from teal to purple border */\n  color: #c4b5fd;\n}\n\n.dark-mode .chat-message.error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid #ef4444; /* 1px border */\n  color: #dc2626;\n}\n\n.dark-mode .message-username {\n  color: #c4b5fd;\n}\n\n.dark-mode .message-time {\n  color: #9ca3af;\n}\n\n.light-mode .chat-message {\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(139, 92, 246, 0.5); /* 1px purple border for regular messages */\n  color: #ffffff; /* White text for readability */\n}\n\n.light-mode .chat-message.system {\n  background: rgba(139, 92, 246, 0.15);\n  border: 1px solid rgba(139, 92, 246, 0.6); /* UPDATED: Changed from teal to purple border */\n  color: #e9d5ff; /* Light purple text */\n}\n\n.light-mode .chat-message.error {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.6); /* 1px border */\n  color: #fca5a5; /* Light red text */\n}\n\n.light-mode .message-username {\n  color: #c4b5fd; /* Light purple for username */\n}\n\n.light-mode .message-time {\n  color: #d1d5db; /* Light gray for timestamp */\n}\n\n.chat-message {\n  border-radius: 4px;\n  padding: 8px 12px;\n  flex-shrink: 0;\n  width: 100%;\n  box-sizing: border-box;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  margin: 0;\n}\n\n.chat-message.system {\n  text-align: center;\n  font-style: italic;\n}\n\n/* Seasonal theme gradient borders for chat messages - using border-image for simplicity */\n.app.seasonal-theme .chat-message {\n  border: 1px solid;\n  border-image: linear-gradient(\n    90deg,\n    #7c3aed,  /* VIVID purple */\n    #ff6b00,  /* VIVID orange */\n    #a21caf   /* VIVID magenta */\n  ) 1;\n}\n\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  width: 100%;\n}\n\n.message-username {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.message-time {\n  font-size: 11px;\n}\n\n.message-content {\n  font-size: 14px;\n  line-height: 1.4;\n  width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: pre-wrap; /* Preserve newlines while allowing text wrapping */\n}\n\n/* Input Area Styling */\n.dark-mode .chat-input-area {\n  background: transparent;\n}\n\n.light-mode .chat-input-area {\n  background: transparent;\n}\n\n.chat-input-container {\n  display: flex;\n  gap: 8px;\n}\n\n/* Input Fields */\n.dark-mode .chat-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.05);\n  color: white;\n  font-size: 14px;\n  outline: none;\n}\n\n.dark-mode .chat-input:focus {\n  border-color: #5b21b6;\n  box-shadow: 0 0 0 2px rgba(91, 33, 182, 0.2);\n}\n\n.dark-mode .chat-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.light-mode .chat-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n}\n\n.light-mode .chat-input:focus {\n  border-color: #5b21b6;\n  box-shadow: 0 0 0 2px rgba(91, 33, 182, 0.2);\n}\n\n.light-mode .chat-input::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.chat-send {\n  padding: 8px 16px;\n  background: #5b21b6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.chat-send:hover:not(:disabled) {\n  background: #4c1d95;\n}\n\n.chat-send:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.chat-status {\n  margin-top: 4px;\n  font-size: 12px;\n  min-height: 14px;\n}\n\n.dark-mode .chat-status {\n  color: #9ca3af;\n}\n\n.light-mode .chat-status {\n  color: #6b7280;\n}\n\n/* REMOVED: Chat status styling since div was removed */\n/* Seasonal pumpkin - hidden by default */\n.seasonal-pumpkin {\n  display: none;\n  font-size: 32px;\n}\n\n/* Show pumpkin when seasonal theme is active */\n.app.seasonal-theme .seasonal-pumpkin {\n  display: inline;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .chat-container {\n    width: 100vw;\n    height: 100vh;\n  }\n\n  .chat-container.collapsed {\n    transform: translateX(100%);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
